<template>
    <div class="text-center">
    <v-tooltip :bottom="!tooltipAlign || tooltipAlign == 'bottom'" :right="tooltipAlign == 'right'" :left="tooltipAlign == 'left'" :top="tooltipAlign == 'top'">
    <template v-slot:activator="{ on, attrs }">
        <v-progress-circular
            v-on="showToolTip ? on : false"
            v-bind="showToolTip ? attrs: undefined"
            class="bee-circle"
            :class="color ? `${color}--text` : 'addingColor--text'"
            :rotate="rotate ? rotate : -90"
            :size="size"
            :width="width ? width : 11"
            :value="value"
            :indeterminate="indeterminate">
            <slot name="content"></slot>
            <span class="red--text pb-0" style="line-height: 1.2;"> {{title}} <br><v-card-subtitle style="color:  rgba(255, 0, 0, 0.6); line-height: 1;" class="pa-0"> {{subtitle}} </v-card-subtitle> </span>
        </v-progress-circular>
    </template>
        <span>
            {{tooltip}}
        </span>
    </v-tooltip>
    </div>
</template>
<script>
export default {
name: 'BeeProgressCircular',
props:["value","color", "width", "size", "title", "subtitle", "tooltip", "tooltipAlign", "indeterminate", "rotate"],
computed:{
    showToolTip(){return this.tooltip ? true : false}
}
}
</script>